// src/PrivacyPolicy.js
import React from "react";
import logo from "./logo.svg";

const PrivacyPolicy = ({ appName }) => {
  const privacyPolicyContent = `
1. 引言
  歡迎使用 ${appName}（以下簡稱“本應用”）。我們重視您的隱私，並致力於保護您的個人信息。本隱私政策說明了我們如何收集、使用、儲存和保護您的信息。

2. 我們收集的數據
  1. 個人信息：
    聯絡方式：如電子郵件地址、電話號碼。
  
  2. 使用數據：
    應用使用情況：如您如何使用應用程序、您的訪問時間和頻率。

3. 我們如何使用您的數據
  我們可能會使用您的數據來：
    提供和維護本應用的服務。
    處理您的交易或請求。
    改進本應用的功能和用戶體驗。

4. 如何共享您的數據
  我們不會將您的個人信息出售或租賃給第三方。我們可能會在以下情況下共享您的信息：
    服務提供商：我們可能會與第三方服務提供商共享數據以協助我們提供服務。

5. 數據保護
  我們採取適當的技術和組織措施來保護您的個人信息不被未經授權的訪問、使用或披露。

6. 用戶權利
  您有權：
    訪問：查看我們所持有的關於您的個人數據。
    修改：要求更正不準確的數據。

7. Cookie 和其他跟踪技術
  本應用可能使用 Cookie 和其他跟踪技術來收集和存儲您的偏好設置和使用數據。

8. 未成年人的隱私
  我們不會故意收集 13 歲以下兒童的個人信息。

9. 隱私政策的更新
  我們可能會不定期更新本隱私政策。任何變更將在本頁面上發布。

10. 聯繫我們
  如果您對本隱私政策有任何疑問或擔憂，請聯繫我們：
  電子郵件： otislin1102@gmail.com
`;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        width: "100vw",
        overflowY: "auto",
      }}
    >
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <div
        style={{ textAlign: "left", padding: "20px", whiteSpace: "pre-wrap" }}
      >
        <h1 className="main-font-color">隱私政策</h1>
        <div className="main-font-color">{privacyPolicyContent}</div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
